import React from 'react'
import { ChipFieldProps, TextFieldProps } from 'react-admin'
import { useLangContext } from 'services/contexts/LangContext'
import { useKRecordContext } from 'services/hooks/useKRecordContext'
import { parseMultilangJSON } from 'services/utils/multilangParseWrite'

type Props<T extends TextFieldProps | ChipFieldProps> = T & {
  source: string
  children: React.ReactElement
}

const LocalizedField = function <
  TChildProp extends TextFieldProps | ChipFieldProps
>({ children, source, ...rest }: Props<TChildProp>): JSX.Element {
  const record = useKRecordContext()

  const { currentLang } = useLangContext()
  const translated = parseMultilangJSON(record?.[source])[currentLang]

  return React.cloneElement(children, {
    ...rest,
    record: {
      id: record?.id,
      [source!]: translated,
    },
    source,
  })
}

export default LocalizedField
